import React, {Component} from 'react';
import {FormControl} from 'react-bootstrap';
import PropTypes from 'prop-types';
import './LoginPage.scss';
import logo from '../assets/img/logo.svg';
import iconsSvg from '../assets/img/svgLib/iconsSvg';
import classNames from 'classnames';
import ModalWindow from '../shared/ModalWindow/ModalWindow';
// import request from 'superagent';

class LoginPage extends Component {
    static propTypes = {
      classPrefix: PropTypes.string,
      handleLoginAction: PropTypes.func,
    }

    constructor(props) {
      super(props);

      this.state = {
        loginValue: '',
        passValue: '',
        emailRestore: '',
        modalOpen: false,
        activeItem: 'login',
        role: null,
        registrationStep: null,
        regDataBig: {
          name: '',
          surename: '',
          middle_name: '',
          phone: '',
          email: '',
          nameCompany: '',
          inn: '',
          kpp: '',
          ogrn: '',
          okpo: '',
        },
        regDataSmall: {
          name: '',
          surename: '',
          phone: '',
          email: '',
          nameCompany: '',
        },
        emptyFieldAlert: false,
        twoStepRegistration: false,
        userInfo: {},
      };
    }

    componentWillMount() {
      document.addEventListener('keydown', this.handleEnterPress, false);
    }

    componentWillUnmount() {
      document.removeEventListener('keydown', this.handleEnterPress, false);
    }

    isEmpty(obj) {
      return new Promise((res, err) => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key) && obj[key].length === 0) {
            this.setState({
              emptyFieldAlert: true,
            });
            return;
          }
        }
        this.setState({
          emptyFieldAlert: false,
        });
        res(true);
      });
    }

    getAuthUserData = (login, password) => { // TODO временно выпелено дял показа
      return new Promise((resolve, err) => {
        /* request
                    .post('http://localhost:8000/users/login')
                    .set({
                        Accept: 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    })
                    .send({
                        password: password,
                        login: login
                    })
                    .end((err,res) => {
                        if (res) {
                            this.setState({
                                userInfo: JSON.parse(res.body.res),
                            });
                            resolve(JSON.parse(res.body.res));
                        }
                    });*/
        const user = {
          companyId: 1,
          email: 'factor@factor.ru',
          id: 1,
          login: 'factor',
          middleName: 'Валерьевич',
          name: 'Александр',
          password: 'factor',
          role: 'factor',
          status: 'enabled',
          surename: 'Довженок',
        };
        this.setState({
          userInfo: user,
        });
        resolve(user); // TODO DELETE!!!!!!!!!!!!!!!!!!
      });
    }

    clickTwoStepRegistration = () => {
      this.setState({
        twoStepRegistration: true,
      });
    };

    sendRegistrationForm = (role, regData) => {
      // const req = {
      //   role,
      //   regData,
      //   status: 'review',
      //   status_view: 'new',
      // };
    // request
    //     .post('http://localhost:8000/registration/create')
    //     .set({
    //         Accept: 'application/json',
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //     })
    //     .send(req)
    //     .end((err, res) => {
    //         if (res) {
    //         }
    //     });
    }

    clickToSendRegistration = () => {
      const {regDataBig, regDataSmall, role} = this.state;
      const regData = role === 'vendor' ? regDataBig : regDataSmall;
      this.isEmpty(regData).then((res) => {
        if (res) {
          this.sendRegistrationForm(role, regData);
          this.setState({
            activeItem: 'login',
            emptyFieldAlert: false,
            registrationStep: null,
            role: null,
            twoStepRegistration: false,
            regDataBig: {
              name: '',
              surename: '',
              middle_name: '',
              phone: '',
              email: '',
              nameCompany: '',
              inn: '',
              kpp: '',
              ogrn: '',
              okpo: '',
            },
            regDataSmall: {
              name: '',
              surename: '',
              phone: '',
              email: '',
              nameCompany: '',
            },
          });
        }
      });
    };

    handleChangeLogin = (e) => {
      this.setState({
        loginValue: e.target.value,
      });
    };

    handleChangePassword = (e) => {
      this.setState({
        passValue: e.target.value,
      });
    };

    handleChangeInputForm = (e) => {
      const {regDataBig, regDataSmall, role} = this.state;
      const regData = role === 'vendor' ? regDataBig : regDataSmall;
      const key = e.target.dataset.field;
      const val = e.target.value;
      let formatVal;

      switch (key) {
        case 'phone':
        case 'inn':
        case 'kpp':
        case 'ogrn':
        case 'okpo':
          const regex = /[^+0-9]/;
          const phoneRegex = /^([8,+7]{1,2})(\d{3})(\d{3})(\d{2})(\d{2})$/g;
          formatVal = val.replace(regex, '').replace(phoneRegex, '$1 ($2) $3 $4 $5');
          break;
        default:
          formatVal = val;
          break;
      }

      regData[key] = formatVal;
        role === 'vendor' ?
            this.setState({
              regDataBig: regData,
            }) : this.setState({
              regDataSmall: regData,
            });
    };

    handleEnterPress = (event) => {
      const {activeItem, loginValue, passValue} = this.state;
      const codeKey = event.keyCode;

      // login api method!
      if (codeKey === 13) {
        activeItem === 'login' && loginValue.length &&
            this.getAuthUserData(loginValue, passValue).then((res) => {
              this.props.handleLoginAction(res);
            });
      }
    }

    handleNextClickButton = (activeItem) => { // TODO f() авторизации ОСНОВНАЯ ЧАСТЬ! Сюда добавляем JWT
      const {passValue, loginValue} = this.state;
      activeItem === 'login' &&
        this.getAuthUserData(loginValue, passValue).then((res) => {
            res ?
                this.props.handleLoginAction(res) :
                this.setState({
                  registrationStep: this.state.registrationStep + 1,
                });
        }
        );
    };

    handleHeadClick = (type) => {
      const {registrationStep} = this.state;
      this.setState({
        activeItem: type,
        registrationStep: type === 'registration' ?
            !registrationStep ? 1 : registrationStep >= 1 ?
                registrationStep : null : null,
      });
    };

    handleRoleChoose = (role) => {
      this.setState({
        role,
      });
    };

    modalHandler = (modal) => {
      this.setState({
        modalOpen: modal,
      });
    }

    handleBackToStepOne = () => {
      this.setState({
        registrationStep: this.state.registrationStep - 1,
        emptyFieldAlert: false,
        twoStepRegistration: false,
      });
    };

    handleStepOneNextButton = (role) => {
      role && this.setState({
        registrationStep: this.state.registrationStep + 1,
      });
    };

    get emptyTxt() {
      return (<div className={'emptyTxt'}>Не заполнено</div>);
    }

    get stepOne() {
      const {role, activeItem} = this.state;
      return (
        <div className={`loginForm`}>
          <div className={'loginFormHead'}>
            <div className={classNames('loginFormEnter', {
              'active': activeItem === 'login',
            })}
            onClick={() => this.handleHeadClick('login')}>Вход</div>
            <div className={classNames('loginFormRegistration', {
              'active': activeItem === 'registration',
            })}
            onClick={() => this.handleHeadClick('registration')}>
                        Регистрация
            </div>
          </div>
          <div className={'formHeadLabel'}>
                    Выберите роль:
          </div>
          <div className={'step1Registration'}>
            <div
              className={'roleItem'}
              onClick={() => this.handleRoleChoose('vendor')}>
              <div className={classNames('checkButton', {
                'active': role === 'vendor',
              })} />
              <div className={'roleTxt'}>
                        Поставщик
              </div>
            </div>
            <div
              className={'roleItem'}
              onClick={() => this.handleRoleChoose('debtor')}>
              <div className={classNames('checkButton', {
                'active': role === 'debtor',
              })} />
              <div className={'roleTxt'}>
                        Дебитор
              </div>
            </div>
            <div className={'roleItem'}>
              <div className={classNames('checkButton', {
                'active': role === 'factor',
              })} />
              <div
                className={'roleTxt'}
                onClick={() => this.handleRoleChoose('factor')}>
                        Фактор (Инвестор)
              </div>
            </div>
          </div>
          <div
            className={classNames('buttonNext', {
              'disabled': !role,
            })}
            onClick={() => role &&
                        this.handleStepOneNextButton(role)}>
                    Далее
          </div>
        </div>
      );
    }

    get stepDebtor() {
      const {activeItem, regDataSmall, emptyFieldAlert} = this.state;
      const {name, surename, phone, email, nameCompany} = regDataSmall;
      const {emptyTxt} = this;
      return (
        <div className={`loginForm`} style={{marginTop: '20px'}}>
          <div className={'loginFormHead'}>
            <div className={classNames('loginFormEnter', {
              'active': activeItem === 'login',
            })}
            onClick={() => this.handleHeadClick('login')}>Вход</div>
            <div className={classNames('loginFormRegistration', {
              'active': activeItem === 'registration',
            })}
            onClick={() => this.handleHeadClick('registration')}>
                        Регистрация
            </div>
          </div>
          <div className={'backArrow'}
            onClick={this.handleBackToStepOne}>{iconsSvg.back}</div>
          <div className={'formHeadLabel'}>
                    Дебитор
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && name === ''})}>
            <div className={'formLabel'}>
                        Как вас зовут?
            </div>
            <FormControl
              type={'text'}
              value={name}
              data-field={'name'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && name === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && surename === ''})}>
            <div className={'formLabel'}>
                        Ваша фамилия
            </div>
            <FormControl
              type={'text'}
              value={surename}
              data-field={'surename'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && surename === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && phone === ''})}>
            <FormControl
              type={'text'}
              value={phone}
              data-field={'phone'}
              placeholder={'Номер телефона'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && phone === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && email === ''})}>
            <FormControl
              type={'text'}
              value={email}
              data-field={'email'}
              placeholder={'Ваш e-mail'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && email === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && nameCompany === ''})}>
            <FormControl
              value={nameCompany}
              data-field={'nameCompany'}
              placeholder={'Название фирмы'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && nameCompany === '' ? emptyTxt : null}
          </div>
          <div className={'userLicense'}>
            {`Нажимая кнопку "Отправить", вы соглашаетесь с условием обработки `}
            <span>персональных данных</span>
          </div>
          <div
            className={'buttonNext'}
            onClick={this.clickToSendRegistration}>
                    Отправить запрос
          </div>
        </div>
      );
    }

    get stepFactor() {
      const {activeItem, regDataSmall, emptyFieldAlert} = this.state;
      const {name, surename, phone, email, nameCompany} = regDataSmall;
      const {emptyTxt} = this;
      return (
        <div className={`loginForm`} style={{marginTop: '20px'}}>
          <div className={'loginFormHead'}>
            <div className={classNames('loginFormEnter', {
              'active': activeItem === 'login',
            })}
            onClick={() => this.handleHeadClick('login')}>Вход</div>
            <div className={classNames('loginFormRegistration', {
              'active': activeItem === 'registration',
            })}
            onClick={() => this.handleHeadClick('registration')}>
                        Регистрация
            </div>
          </div>
          <div className={'backArrow'}
            onClick={this.handleBackToStepOne}>{iconsSvg.back}</div>
          <div className={'formHeadLabel'}>
                    Фактор (Инвестор)
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && name === ''})}>
            <div className={'formLabel'}>
                        Как вас зовут?
            </div>
            <FormControl
              type={'text'}
              value={name}
              data-field={'name'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && name === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && surename === ''})}>
            <div className={'formLabel'}>
                        Ваша фамилия
            </div>
            <FormControl
              type={'text'}
              value={surename}
              data-field={'surename'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && surename === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && phone === ''})}>
            <FormControl
              type={'text'}
              value={phone}
              data-field={'phone'}
              placeholder={'Номер телефона'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && phone === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && email === ''})}>
            <FormControl
              type={'text'}
              value={email}
              data-field={'email'}
              placeholder={'Ваш e-mail'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && email === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && nameCompany === ''})}>
            <FormControl
              value={nameCompany}
              data-field={'nameCompany'}
              placeholder={'Название фирмы'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && nameCompany === '' ? emptyTxt : null}
          </div>
          <div className={'userLicense'}>
            {`Нажимая кнопку "Отправить", вы соглашаетесь с условием обработки `}
            <span>персональных данных</span>
          </div>
          <div
            className={'buttonNext'}
            onClick={this.clickToSendRegistration}>
                    Отправить запрос
          </div>
        </div>
      );
    }

    get vendorStepOne() {
      const {activeItem, regDataBig, emptyFieldAlert,
        twoStepRegistration} = this.state;
      const {name, surename, phone, email, middle_name} = regDataBig;
      const {emptyTxt} = this;

      return (
        <div className={`loginForm`} style={{marginTop: '20px'}}>
          <div className={'loginFormHead'}>
            <div className={classNames('loginFormEnter', {
              'active': activeItem === 'login',
            })}
            onClick={() => this.handleHeadClick('login')}>
                        Вход
            </div>
            <div className={classNames('loginFormRegistration', {
              'active': activeItem === 'registration',
            })}
            onClick={() =>
              this.handleHeadClick('registration')}>
                        Регистрация
            </div>
          </div>
          <div className={'backArrow'}
            onClick={this.handleBackToStepOne}>
            {iconsSvg.back}
          </div>
          <div className={'formHeadLabel'}>
                    Поставщик
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && name === ''})}>
            <FormControl
              type={'text'}
              value={name}
              data-field={'name'}
              placeholder={'Как вас зовут?'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && name === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && surename === ''})}>
            <FormControl
              type={'text'}
              value={surename}
              data-field={'surename'}
              placeholder={'Ваша фамилия'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && surename === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && middle_name === ''})}>
            <FormControl
              type={'text'}
              value={middle_name}
              data-field={'middle_name'}
              placeholder={'Отчество'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && middle_name === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && phone === ''})}>
            <FormControl
              type={'text'}
              value={phone}
              data-field={'phone'}
              placeholder={'Номер телефона'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && phone === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && email === ''})}>
            <FormControl
              type={'text'}
              value={email}
              data-field={'email'}
              placeholder={'Ваш e-mail'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && email === '' ? emptyTxt : null}
          </div>
          <div
            className={classNames({
              'disabled': twoStepRegistration,
            }, 'buttonNext')}
            onClick={this.clickTwoStepRegistration}>
                    Далее
          </div>
        </div>
      );
    }

    get vendorStepTwo() {
      const {activeItem, regDataBig, emptyFieldAlert} = this.state;
      const {nameCompany, inn, kpp, okpo, ogrn} = regDataBig;
      const {emptyTxt} = this;

      return (
        <div className={`loginForm`} style={{marginTop: '20px'}}>
          <div className={'loginFormHead'}>
            <div className={classNames('loginFormEnter', {
              'active': activeItem === 'login',
            })}
            onClick={() => this.handleHeadClick('login')}>
                        Вход
            </div>
            <div className={classNames('loginFormRegistration', {
              'active': activeItem === 'registration',
            })}
            onClick={() =>
              this.handleHeadClick('registration')}>
                        Регистрация
            </div>
          </div>
          <div className={'backArrow'}
            onClick={this.handleBackToStepOne}>
            {iconsSvg.back}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && nameCompany === ''})}>
            <FormControl
              type={'text'}
              value={nameCompany}
              data-field={'nameCompany'}
              placeholder={'Название фирмы'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && nameCompany === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && inn === ''})}>
            <FormControl
              type={'text'}
              value={inn}
              data-field={'inn'}
              placeholder={'ИНН'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && inn === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && kpp === ''})}>
            <FormControl
              type={'text'}
              value={kpp}
              data-field={'kpp'}
              placeholder={'КПП'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && kpp === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && ogrn === ''})}>
            <FormControl
              type={'text'}
              value={ogrn}
              data-field={'ogrn'}
              placeholder={'ОГРН'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && ogrn === '' ? emptyTxt : null}
          </div>
          <div className={classNames('loginFormInput',
              {'empty': emptyFieldAlert && okpo === ''})}>
            <FormControl
              type={'text'}
              value={okpo}
              data-field={'okpo'}
              placeholder={'ОКПО'}
              onChange={this.handleChangeInputForm} />
            {emptyFieldAlert && okpo === '' ? emptyTxt : null}
          </div>
          <div className={'userLicense'}
            style={{marginTop: '25px', marginBottom: '48px'}}>
            {`Нажимая кнопку "Отправить", вы соглашаетесь с условием обработки `}
            <span>персональных данных</span>
          </div>
          <div
            className={'buttonNext'}
            onClick={this.clickToSendRegistration}>
                    Отправить запрос
          </div>
        </div>
      );
    }

    get stepVendor() {
      const {vendorStepOne, vendorStepTwo} = this;
      const {twoStepRegistration} = this.state;
      return (
        <div className={'stepTwoTwo'}>
          {vendorStepOne}
          {twoStepRegistration ? vendorStepTwo : null}
        </div>
      );
    }

    loginForm() {
      const {loginValue, passValue, activeItem} = this.state;
      return (
        <div className={`loginForm`}>
          <div className={'loginFormHead'}>
            <div className={classNames('loginFormEnter', {
              'active': activeItem === 'login',
            })}
            onClick={() => this.handleHeadClick('login')}>
                        Вход
            </div>
            <div className={classNames('loginFormRegistration', {
              'active': activeItem === 'registration',
            })}
            onClick={() => this.handleHeadClick('registration')}>
                        Регистрация
            </div>
          </div>
          <div className={'loginFormInput'}>
            <div className={'formLabel'}>
                        Логин
            </div>
            <FormControl
              type={'text'}
              value={loginValue}
              onChange={this.handleChangeLogin} />
          </div>
          <div className={'loginFormInput'}>
            <FormControl
              type={'password'}
              value={passValue}
              placeholder={'Пароль'}
              onChange={this.handleChangePassword} />
          </div>
          <div className={'forgotLink'}
            onClick={() => this.modalHandler(true)}>
                    Забыли пароль?
          </div>
          <div
            className={classNames('buttonNext', {
              'disabled': !loginValue,
            })}
            onClick={() => loginValue &&
                        this.handleNextClickButton(activeItem)}>
                    Далее
          </div>
        </div>
      );
    }

    get recoveryForm() {

    }

    get loginPageBlock() { // Блок регистрации логирования, рековери, регистрации - внутренности по геттерам *Form
      const {activeItem, registrationStep, role} = this.state;
      const {stepOne, recoveryForm, stepDebtor, stepVendor,
        stepFactor} = this;

      return (
        <div className={`loginBlock`}>
          {activeItem === 'login' ?
                    this.loginForm() : activeItem === 'registration' &&
                    registrationStep === 1 ?
                        stepOne : registrationStep === 2 ?
                            role === 'debtor' ? stepDebtor :
                                role === 'vendor' ? stepVendor :
                                    stepFactor : recoveryForm}
        </div>);
    }

    linkToSite = () => {
      return window.location.href = 'http://factoroil.com/';

    };

    render() {
      const {loginPageBlock} = this;
      const {classPrefix} = this.props;
      const {modalOpen} = this.state;
      const modalWindow = (
        <ModalWindow
          type={'restore'}
          buttonTxt={'Восстановить'}
          show={modalOpen}
          text={'На вашу почту будет отправлена инструкция по восстановлению пароля'}
          title={'Забыли пароль?'}
          classPrefix={classPrefix}
          handler={this.modalHandler} />);

      return (
        <div className={`loginPage${classPrefix}`}>
          <div className={'loginFormLabel'}><img src={logo} alt={''} onClick={this.linkToSite} /></div>
          {loginPageBlock}
          {modalOpen && modalWindow}
        </div>
      );
    }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/LoginPage/LoginPage.js